import React from 'react';
import SubHeader from '../../../common/subHeader';
import Divider from '../../../common/divider';
import ATable from '../../../common/table';

const columns = [

    {
        header: "Date",
        accessor: "addedOn",
    },
    {
        header: "User",
        accessor: "addedBy"
    },

    {
        header: "Details",
        accessor: "detail",
        width : 500, 
        render : (row) =>{
            return (<div style={{whiteSpace : "normal"}}>{row.row.detail}</div>)
        }
    },

];

const DisputeModalJournal = (props) => {
    let dispute = props.dispute;
    return (
        <div>
            <Divider />
            <SubHeader title="Audit" />
            <Divider />
            {

                dispute && dispute.journal &&
                <ATable
                    className="-striped -highlight"
                    tableData={dispute.journal}
                    columns={columns}
                    defaultPageSize={5}
                />

            }

        </div>
    );
};

export default DisputeModalJournal;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModalJournal.js